export default __webpack_public_path__ + "static/media/PacificPoint.2a9cbc50.png";